import { logPlatformDiff } from './logger';
import { PLATFORM_TYPE, platformCache } from './platformCache';
import { USEQuery } from './constant';
export function getIsInUseFromUrl() {
    const excludes = ['/main', '/index'];
    const newUrl = new URL(window.location.href);
    const searchParams = (newUrl.searchParams as any).size
        ? newUrl.searchParams
        : new URLSearchParams(window.location.href.split('?')[1]);
    const isInUSE =
        String(searchParams.get(USEQuery)) === '1' ||
        window.location.pathname === '/use' ||
        window.location.pathname.startsWith('/use/');
    return isInUSE && !excludes.includes(window.location.pathname);
}
export { USEQuery };
export function hasUsePlatform() {
    const { data }: any = window?.pageData || {};
    const { enterprise_info: enterpriseInfo } = data?.user_info || {};
    const { platform_permission } = enterpriseInfo || {};
    return platform_permission == 2 || platform_permission == 3;
}
/**
 * 统一收口判断是否是 USE 平台，所有判断是否是USE平台的地方都统一调用这个方法
 * 默认不是用缓存，只有 logo 跳转的地方使用缓存，其他地方不使用缓存，还是根据 url 参数判断,
 * @returns
 */
export const isInUse = (option?: IsInUseOptions) => {
    const { useCache = false } = option || {};
    const isInUseFromUrl = getIsInUseFromUrl();
    const isUSEFromCache = platformCache.getPlatform() === PLATFORM_TYPE.USE;
    if (isInUseFromUrl !== isUSEFromCache) {
        // log不一致的情况
        logPlatformDiff(isInUseFromUrl, isUSEFromCache);
    }
    return isInUseFromUrl || (useCache && isUSEFromCache);
};

export function getSeId() {
    const { data }: any = window?.pageData || {};
    const { enterprise_info: enterpriseInfo } = data?.user_info || {};
    const { se_platform } = enterpriseInfo || {};
    const se_id = se_platform?.current?.id;

    return se_id;
}
export const getQueryUseParamsExpand = (): Record<string, string> => {
    const seId = getSeId() as string;
    const isInUsePage = isInUse();
    if (isInUsePage && seId) {
        return {
            se_id: seId,
        };
    }
    return {};
};
export function addPathToUrl(url: string, addPath: string) {
    const urlObj = new URL(url, window.location.origin); // window.location.origin 用于处理相对 URL
    const currentPath = urlObj.pathname;
    // 确保路径以 / 开头且不重复添加 /
    const updatedPath = `${currentPath.replace(/\/$/, '')}/${addPath.replace(/^\//, '')}`;
    urlObj.pathname = updatedPath;
    return urlObj.toString();
}

interface IsInUseOptions {
    /**是否使用缓存 */
    useCache?: boolean;
}

/**
 * 统一收口设置当前是否是 USE 平台。
 * 调用时机：现在只有在 use 首页和学习平台首页加载时调用。
 * 保存策略：现在是使用 localStorage 保存，后续如果有更优方案再做调整。
 * @param isUSE boolean 是否是 USE 平台
 */
export const setIsInUse = (isUSE: boolean) => {
    platformCache.setPlatform(isUSE ? PLATFORM_TYPE.USE : PLATFORM_TYPE.LEARNING);
};
